import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import moment from "moment";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { HandlePurchaseRequestStatus } from "../../../utility/CommonFunctions";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import Logs from "../../Logs/Logs";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import EyeOpenIcon from "../../../components/Icons/EyeOpenIcon";
import CheckIcon from "../../../components/Icons/CheckIcon";
import CrossIcon from "../../../components/Icons/CrossIcon";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import MainHeading from "../../../components/comman/MainHeading";

export default function PurchaseRequestDetails() {
  const { id } = useParams();
  const userDetails = useSelector((state) => state.root.userDetails);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [purchaseReqData, setPurchaseReqData] = useState();
  const [modalType, setModalType] = useState("");
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };
  const [docModal, setDocModal] = useState(false);
  const toggleDocModal = () => {
    setDocModal(!docModal);
  };
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [refreshLogs, setRefreshLogs] = useState(false);

  useEffect(() => {
    GetSupplyRequestDetail();
  }, [id]);

  const GetSupplyRequestDetail = () => {
    const options = {
      method: "GET",
    };
    const API = apiUrl?.get_purchase_request_detail + `?purchaseRequestId=${id}`;
    callApi(API, options).then((response) => {
      setDataLoading(false);
      if (response?.status === true) {
        setPurchaseReqData(response?.data);
      }
    });
  };

  const handleReqStatus = (status, reason = "") => {
    const postData = {
      status: status,
      ...(status === "Rejected" && { rejectReason: reason }),
      ...(status === "Hold" && { holdReason: reason, reason: reason }),
    };
    const option = {
      method: "POST",
      data: postData,
    };

    setIsLoading(true);
    callApi(
      apiUrl.update_purchase_request_status + `?purchaseRequestId=${id}`,
      option
    )
      .then((res) => {
        setIsLoading(false);
        if (res?.status === true) {
          toast.success(res?.message);
          GetSupplyRequestDetail();
          setRefreshLogs(true);
        } else {
          toast.error(res?.message);
        }
        toggle();
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    toggleDocModal();
  };

  // Cross-checked conditions: 100% faithful to original logic
  const isStatusNotPoCreated = Boolean(
    purchaseReqData && purchaseReqData?.status !== "PO Created"
  );

  // 1. Create PO condition
  const canCreatePO = Boolean(
    purchaseReqData?.canCreatePO &&
    isStatusNotPoCreated &&
    userDetails?.designation?.canCreate?.includes("po")
  );

  // 2. Reject condition (visible as long as status !== "PO Created")
  const canReject = isStatusNotPoCreated;

  // 3. Hold condition (status !== "PO Created" && canChangeStatus && !status.includes("Hold"))
  const canHold = Boolean(
    isStatusNotPoCreated &&
    purchaseReqData?.canChangeStatus &&
    !purchaseReqData?.status?.includes("Hold")
  );

  // 4. Approve condition (status !== "PO Created" && canChangeStatus && !status.includes("Hold"))
  const canApprove = Boolean(
    isStatusNotPoCreated &&
    purchaseReqData?.canChangeStatus &&
    !purchaseReqData?.status?.includes("Hold")
  );

  const hasAnyAction = canCreatePO || canReject || canHold || canApprove;

  const totalItemsCount =
    purchaseReqData?.purchaserequestexpenseheads?.reduce(
      (sum, head) => sum + (head?.supplyrequestitems?.length || 0),
      0
    ) || 0;

  const renderActionButtons = (size = "md") => {
    const isSmall = size === "sm";
    const btnClass = isSmall ? "btn btn-sm" : "btn";

    return (
      <div className="d-flex align-items-center flex-wrap gap-2">
        {/* Reject Button */}
        {canReject && (
          <button
            onClick={() => {
              setModalType("reject");
              toggle();
            }}
            className={`${btnClass} btn-outline-danger d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-2`}
            type="button"
            title="Reject Purchase Request"
          >
            <CrossIcon width="12" height="12" />
            <span>Reject</span>
          </button>
        )}

        {/* Hold Button */}
        {canHold && (
          <button
            onClick={() => {
              setModalType("hold");
              toggle();
            }}
            className={`${btnClass} btn-outline-warning d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-2`}
            type="button"
            title="Put Purchase Request on Hold"
          >
            <span>⏸</span>
            <span>Hold</span>
          </button>
        )}

        {/* Approve Button */}
        {canApprove && (
          <button
            onClick={() => {
              setModalType("approve");
              toggle();
            }}
            className={`${btnClass} btn-success d-inline-flex align-items-center gap-1.5 fw-semibold px-3.5 py-2 text-white shadow-sm`}
            style={{ background: "#059669", borderColor: "#059669" }}
            type="button"
            title="Approve Purchase Request"
          >
            <CheckIcon />
            <span>Approve</span>
          </button>
        )}

        {/* Create PO Button */}
        {canCreatePO && (
          <button
            onClick={() => {
              setModalType("approve");
              toggle();
              navigate(RoutesLink?.create_purchase, {
                state: {
                  data: purchaseReqData,
                  type: "Create",
                },
              });
            }}
            className={`${btnClass} btn-primary d-inline-flex align-items-center gap-2 fw-semibold px-4 py-2 shadow-sm text-white`}
            style={{ background: "#4f46e5", borderColor: "#4f46e5" }}
            type="button"
            title="Generate Purchase Order from this Request"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="12" y1="18" x2="12" y2="12"></line>
              <line x1="9" y1="15" x2="15" y2="15"></line>
            </svg>
            <span>Create PO</span>
          </button>
        )}
      </div>
    );
  };

  return (
    <>
      {dataLoading && <BgBlurLoader />}

      <div className="content container-fluid pb-5">
        {/* Main Header with Top Action Cluster */}
        <MainHeading title="Purchase Request Detail" showBackButton={true}>
        </MainHeading>

        {/* Hold Alert Notice Banner */}
        {(purchaseReqData?.status?.includes("Hold") || purchaseReqData?.holdReason) && (
          <div
            className="alert border-0 rounded-3 p-3 mb-4 d-flex align-items-start gap-3 shadow-sm"
            style={{
              background: "#fffbeb",
              borderLeft: "4px solid #f59e0b",
            }}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                background: "#fef3c7",
                color: "#b45309",
                width: "36px",
                height: "36px",
                fontSize: "14px",
              }}
            >
              ⏸
            </div>
            <div className="flex-grow-1">
              <div className="fw-bold text-dark mb-1" style={{ fontSize: "14px" }}>
                Purchase Request is currently on Hold
              </div>
              <div style={{ color: "#78350f", fontSize: "13px" }}>
                <strong>Reason: </strong>
                {purchaseReqData?.holdReason || "This purchase request is currently placed on hold pending review."}
              </div>
            </div>
            <span
              className="badge rounded-pill px-3 py-1 flex-shrink-0"
              style={{ background: "#fde68a", color: "#92400e", fontWeight: 600 }}
            >
              {purchaseReqData?.status}
            </span>
          </div>
        )}

        {/* Rejected Alert Notice Banner */}
        {purchaseReqData?.rejectReason && (
          <div
            className="alert border-0 rounded-3 p-3 mb-4 d-flex align-items-start gap-3 shadow-sm"
            style={{
              background: "#fef2f2",
              borderLeft: "4px solid #ef4444",
            }}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                background: "#fee2e2",
                color: "#dc2626",
                width: "36px",
                height: "36px",
                fontSize: "14px",
              }}
            >
              ✕
            </div>
            <div className="flex-grow-1">
              <div className="fw-bold text-dark mb-1" style={{ fontSize: "14px" }}>
                Purchase Request Rejected
              </div>
              <div style={{ color: "#991b1b", fontSize: "13px" }}>
                <strong>Reason: </strong>
                {purchaseReqData?.rejectReason}
              </div>
            </div>
            <span
              className="badge rounded-pill px-3 py-1 flex-shrink-0"
              style={{ background: "#fecdd3", color: "#9f1239", fontWeight: 600 }}
            >
              {purchaseReqData?.status}
            </span>
          </div>
        )}

        {/* Master Summary Card */}
        <div className="card border-0 shadow-sm rounded-3 mb-4" style={{ background: "#ffffff" }}>
          <div className="card-body p-4">
            {/* Top Identity Strip */}
            <div
              className="d-flex align-items-start justify-content-between flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 p-2.5 flex-shrink-0"
                  style={{
                    background: "#f1f5f9",
                    color: "#334155",
                    width: "48px",
                    height: "48px",
                    fontSize: "20px",
                  }}
                >
                  📋
                </div>
                <div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <h3
                      className="mb-0 fw-bold text-dark"
                      style={{ letterSpacing: "-0.02em", fontSize: "1.35rem" }}
                    >
                      {purchaseReqData?.requestNumber || "--"}
                    </h3>
                    <span
                      className="badge rounded-pill px-2.5 py-1 fw-semibold d-inline-flex align-items-center gap-1"
                      style={{
                        fontSize: "12px",
                        background:
                          purchaseReqData?.type === "supplyRequest" ? "#eff6ff" : "#faf5ff",
                        color:
                          purchaseReqData?.type === "supplyRequest" ? "#1d4ed8" : "#7e22ce",
                        border: `1px solid ${purchaseReqData?.type === "supplyRequest" ? "#bfdbfe" : "#e9d5ff"
                          }`,
                      }}
                    >
                      <span style={{ display: "inline-block", transform: "translateY(-1px)" }}>
                        {purchaseReqData?.type === "supplyRequest" ? "📦" : "⚙️"}
                      </span>
                      <span>
                        {purchaseReqData?.type === "supplyRequest"
                          ? "Supply Request"
                          : "Service Request"}
                      </span>
                    </span>
                    <div>{HandlePurchaseRequestStatus(purchaseReqData?.status)}</div>
                  </div>
                  <div className="text-secondary small mt-1 d-flex align-items-center gap-2 flex-wrap">
                    <span className="d-inline-flex align-items-center gap-1">
                      <span style={{ display: "inline-block", transform: "translateY(-1px)" }}>📍</span>
                      <span><strong>Site:</strong> {purchaseReqData?.site?.name || "--"}</span>
                    </span>
                    <span>•</span>
                    <span className="d-inline-flex align-items-center gap-1">
                      <span style={{ display: "inline-block", transform: "translateY(-1px)" }}>📅</span>
                      <span>
                        <strong>Created:</strong>{" "}
                        {purchaseReqData?.createdAt
                          ? moment(purchaseReqData?.createdAt).format("DD-MM-YYYY")
                          : "--"}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              {/* Quick Quantitative Stats */}
              <div className="d-flex align-items-center gap-2">
                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{ background: "#f8fafc", border: "1px solid #e2e8f0", minWidth: "90px" }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{ fontSize: "10.5px", fontWeight: 700, letterSpacing: "0.05em" }}
                  >
                    Total Items
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{ fontSize: "17px", lineHeight: "1.2", marginTop: "2px" }}
                  >
                    {totalItemsCount}
                  </div>
                </div>
                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{ background: "#f8fafc", border: "1px solid #e2e8f0", minWidth: "90px" }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{ fontSize: "10.5px", fontWeight: 700, letterSpacing: "0.05em" }}
                  >
                    Expense Heads
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{ fontSize: "17px", lineHeight: "1.2", marginTop: "2px" }}
                  >
                    {purchaseReqData?.purchaserequestexpenseheads?.length || 0}
                  </div>
                </div>
              </div>
            </div>

            {/* Key Information 4-Column Grid */}
            <div className="row g-3 pt-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{ background: "#f8fafc", border: "1px solid #f1f5f9" }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.05em" }}
                  >
                    Site Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={purchaseReqData?.site?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {purchaseReqData?.site?.name || "--"}
                  </div>
                  <div className="text-secondary small mt-0.5" style={{ fontSize: "11px" }}>
                    Project / O&M Site
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{ background: "#f8fafc", border: "1px solid #f1f5f9" }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.05em" }}
                  >
                    Financial Year
                  </div>
                  <div className="fw-semibold text-dark" style={{ fontSize: "13.5px" }}>
                    {purchaseReqData?.financialYear || "--"}
                  </div>
                  <div className="text-secondary small mt-0.5" style={{ fontSize: "11px" }}>
                    Fiscal Cycle
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{ background: "#f8fafc", border: "1px solid #f1f5f9" }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.05em" }}
                  >
                    Expected Date
                  </div>
                  <div className="fw-semibold text-dark" style={{ fontSize: "13.5px" }}>
                    {purchaseReqData?.expectedDate
                      ? moment(purchaseReqData?.expectedDate).format("DD-MM-YYYY")
                      : "--"}
                  </div>
                  <div className="text-secondary small mt-0.5" style={{ fontSize: "11px" }}>
                    Target Inward Date
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{ background: "#f8fafc", border: "1px solid #f1f5f9" }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.05em" }}
                  >
                    Created By
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={purchaseReqData?.user?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {purchaseReqData?.user?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5 text-truncate"
                    style={{ fontSize: "11px" }}
                  >
                    {purchaseReqData?.user?.designation?.name || "Request Author"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Material / Service Items Tables grouped by Expense Head */}
        {purchaseReqData?.purchaserequestexpenseheads &&
          purchaseReqData?.purchaserequestexpenseheads?.length > 0 ? (
          purchaseReqData.purchaserequestexpenseheads.map((item, index) => (
            <div
              className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
              key={index}
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <div className="d-flex align-items-center gap-2">
                  <div
                    className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                    style={{ background: "#f1f5f9", color: "#475569" }}
                  >
                    <span
                      style={{
                        fontSize: "15px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        lineHeight: 1,
                        transform: "translateY(-1.5px)",
                      }}
                    >
                      🏷️
                    </span>
                  </div>
                  <div>
                    <div
                      className="text-muted text-uppercase"
                      style={{ fontSize: "10.5px", fontWeight: 700, letterSpacing: "0.06em" }}
                    >
                      {purchaseReqData?.type === "supplyRequest"
                        ? "Expense Head"
                        : "Service Type"}
                    </div>
                    <h5 className="mb-0 fw-bold text-dark" style={{ fontSize: "15px" }}>
                      {item?.expensehead?.name || "--"}
                    </h5>
                  </div>
                </div>
                <span
                  className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
                  style={{ fontSize: "12px", fontWeight: 600 }}
                >
                  {item?.supplyrequestitems?.length || 0}{" "}
                  {item?.supplyrequestitems?.length === 1 ? "Line Item" : "Line Items"}
                </span>
              </div>

              <div className="table-responsive">
                <table
                  className="table pr-detail-table align-middle mb-0"
                  style={{ borderCollapse: "separate", borderSpacing: "0" }}
                >
                  <thead style={{ background: "#f8fafc" }}>
                    <tr>
                      <th
                        style={{
                          width: "50px",
                          padding: "12px 20px",
                          fontSize: "11px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                          color: "#64748b",
                        }}
                      >
                        #
                      </th>
                      <th
                        style={{
                          minWidth: "220px",
                          padding: "12px 20px",
                          fontSize: "11px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                          color: "#64748b",
                        }}
                      >
                        Item Name
                      </th>
                      <th
                        style={{
                          width: "130px",
                          padding: "12px 16px",
                          fontSize: "11px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                          color: "#64748b",
                        }}
                      >
                        HSN Code
                      </th>
                      <th
                        style={{
                          width: "100px",
                          padding: "12px 16px",
                          fontSize: "11px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                          color: "#64748b",
                        }}
                      >
                        Unit
                      </th>
                      {purchaseReqData?.type === "serviceRequest" && (
                        <th
                          style={{
                            width: "110px",
                            padding: "12px 16px",
                            fontSize: "11px",
                            fontWeight: 700,
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            color: "#64748b",
                          }}
                        >
                          Month
                        </th>
                      )}
                      <th
                        className="text-end"
                        style={{
                          width: "140px",
                          padding: "12px 16px",
                          fontSize: "11px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                          color: "#64748b",
                        }}
                      >
                        Original Qty
                      </th>
                      <th
                        className="text-end"
                        style={{
                          width: "140px",
                          padding: "12px 16px",
                          fontSize: "11px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                          color: "#64748b",
                        }}
                      >
                        Ordered Qty
                      </th>
                      <th
                        style={{
                          minWidth: "200px",
                          padding: "12px 20px",
                          fontSize: "11px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                          color: "#64748b",
                        }}
                      >
                        Description
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {item?.supplyrequestitems?.length > 0 ? (
                      item.supplyrequestitems.map((item2, index2) => (
                        <tr key={index2} style={{ borderBottom: "1px solid #f1f5f9" }}>
                          <td
                            style={{
                              padding: "14px 20px",
                              fontSize: "13px",
                              color: "#94a3b8",
                              fontWeight: 600,
                            }}
                          >
                            {index2 + 1}
                          </td>
                          <td style={{ padding: "14px 20px" }}>
                            <div className="fw-semibold text-dark" style={{ fontSize: "13.5px" }}>
                              {item2?.item?.name || "--"}
                            </div>
                          </td>
                          <td style={{ padding: "14px 16px", fontSize: "13px", color: "#475569" }}>
                            {item2?.item?.hsnCode || "--"}
                          </td>
                          <td style={{ padding: "14px 16px" }}>
                            <span
                              className="badge rounded-pill bg-light text-secondary border px-2.5 py-1"
                              style={{ fontSize: "11.5px" }}
                            >
                              {item2?.item?.unit || "--"}
                            </span>
                          </td>
                          {purchaseReqData?.type === "serviceRequest" && (
                            <td style={{ padding: "14px 16px", fontSize: "13px", color: "#475569" }}>
                              {item2?.month || "--"}
                            </td>
                          )}
                          <td
                            className="text-end"
                            style={{
                              padding: "14px 16px",
                              fontSize: "13.5px",
                              color: "#64748b",
                              fontWeight: 500,
                            }}
                          >
                            {item2?.quantity || "--"}
                          </td>
                          <td
                            className="text-end"
                            style={{
                              padding: "14px 16px",
                              fontSize: "13.5px",
                              color: "#0f172a",
                              fontWeight: 700,
                            }}
                          >
                            {item2?.updatedQuantity || "--"}
                          </td>
                          <td style={{ padding: "14px 20px", fontSize: "12.5px", color: "#64748b" }}>
                            {item2?.itemDescription || item2?.description || "--"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={purchaseReqData?.type === "serviceRequest" ? 8 : 7}
                          className="text-center py-4 text-muted small fw-bold"
                        >
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          ))
        ) : (
          <div className="card border-0 shadow-sm rounded-3 p-5 text-center bg-white mb-4">
            <span style={{ fontSize: "2rem" }}>📦</span>
            <h6 className="fw-bold mt-2 text-dark">No Data Found</h6>
            <p className="text-muted small mb-0">
              This purchase request does not contain any material or service line items.
            </p>
          </div>
        )}

        {/* Description & Supporting Documents Section */}
        <div className="row g-4 mb-4">
          {/* Attached Documents Card */}
          <div className="col-12 col-lg-5">
            <div className="card border-0 shadow-sm rounded-3 h-100" style={{ background: "#ffffff" }}>
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span
                    style={{
                      fontSize: "16px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      lineHeight: 1,
                      transform: "translateY(-2px)",
                    }}
                  >
                    📎
                  </span>
                  <h5 className="mb-0 fw-bold" style={{ fontSize: "14.5px", color: "#0f172a" }}>
                    Documents
                  </h5>
                </div>
                <span
                  className="badge bg-light text-secondary border px-2.5 py-1 rounded-pill"
                  style={{ fontSize: "11px" }}
                >
                  {purchaseReqData?.documents?.length || 0} Files
                </span>
              </div>
              <div className="card-body p-4">
                {purchaseReqData?.documents && purchaseReqData.documents.length > 0 ? (
                  <div className="d-flex flex-column gap-2">
                    {purchaseReqData.documents.map((doc, index) => (
                      <div
                        key={doc.id || index}
                        role="button"
                        onClick={() => handleDocumentClick(doc)}
                        className="p-3 rounded-2 d-flex align-items-center justify-content-between gap-3 text-decoration-none shadow-sm"
                        style={{
                          background: "#f8fafc",
                          border: "1px solid #e2e8f0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2 overflow-hidden">
                          <div
                            className="rounded-2 p-1.5 d-flex align-items-center justify-content-center flex-shrink-0"
                            style={{
                              background: "#eff6ff",
                              color: "#2563eb",
                              width: "36px",
                              height: "36px",
                            }}
                          >
                            <DocumentIcon />
                          </div>
                          <div className="overflow-hidden">
                            <div
                              className="text-dark fw-semibold text-truncate small"
                              title={doc?.name || "Document"}
                            >
                              {doc?.name || "Document"}
                            </div>
                            <div className="text-muted" style={{ fontSize: "11px" }}>
                              {doc?.updatedAt
                                ? moment(doc?.updatedAt).format("DD MMM YYYY | h:mm a")
                                : "Attached Document"}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className="text-muted small py-4 text-center"
                    style={{
                      background: "#f8fafc",
                      borderRadius: "8px",
                      border: "1px dashed #cbd5e1",
                    }}
                  >
                    No Document Found
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Description Card */}
          <div className="col-12 col-lg-7">
            <div className="card border-0 shadow-sm rounded-3 h-100" style={{ background: "#ffffff" }}>
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center gap-2 border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 1,
                    transform: "translateY(-2px)",
                  }}
                >
                  📝
                </span>
                <h5 className="mb-0 fw-bold" style={{ fontSize: "14.5px", color: "#0f172a" }}>
                  Description
                </h5>
              </div>
              <div className="card-body p-4">
                <div
                  className="p-3 rounded-2"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minHeight: "100px",
                  }}
                >
                  <CKEditor
                    editor={ClassicEditor}
                    data={purchaseReqData?.description || ""}
                    disabled={true}
                    config={{
                      toolbar: [],
                      readOnly: true,
                      image: {
                        toolbar: [
                          "imageStyle:alignLeft",
                          "imageStyle:alignCenter",
                          "imageStyle:alignRight",
                          "|",
                          "imageTextAlternative",
                        ],
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Action Bar */}
        {hasAnyAction && (
          <div
            className="card border-0 shadow-sm rounded-3 mb-4 p-3 d-flex flex-row align-items-center justify-content-between flex-wrap gap-3"
            style={{
              background: "#ffffff",
              borderLeft: "4px solid #4f46e5",
            }}
          >
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span
                className="text-secondary small fw-bold text-uppercase"
                style={{ letterSpacing: "0.04em" }}
              >
                Current Status:
              </span>
              <div>{HandlePurchaseRequestStatus(purchaseReqData?.status)}</div>
            </div>
            <div>{renderActionButtons("md")}</div>
          </div>
        )}

        {/* Audit Trail & Activity Logs */}
        <Logs
          type={"purchaseRequest"}
          id={id}
          refreshLogs={refreshLogs}
          setRefreshLogs={setRefreshLogs}
        />
      </div>

      {/* Document Preview Modal */}
      <ViewDocumentModal
        modal={docModal}
        toggle={toggleDocModal}
        selectedDocument={selectedDocument}
      />

      {/* Approve / Reject / Hold Confirmation Modal */}
      <ApproveRejectModal
        modal={modal}
        toggle={toggle}
        submitHandler={(reason) =>
          handleReqStatus(
            modalType === "reject"
              ? "Rejected"
              : modalType === "hold"
                ? "Hold"
                : "Approved",
            reason
          )
        }
        isLoading={isLoading}
        actionType={modalType}
      />
    </>
  );
}
